module.exports = __webpack_public_path__ + "static/media/blueBanner.efc93400.png";